import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Color from '../models/Color'
import Model from './Parents/Model'

const FILLABEL = ['id', 'sort', 'name', 'color']

export default class ColorType extends Model {
    constructor(data = null) {
        super()
        this.originalData = data

        this.id = 0
        this.sort = 0
        this.name = ''
        this.color = '#dd4b39'

        this.nameChange = false

        this.colors = []

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'ColorType'
    }

    get hasColor() {
        return this.colors.length
    }

    get hasRelation() {
        return this.colors.length
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                if (key === 'colors') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new Color(x))
                        .toArray()
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value)
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/ColorType.js